export const PRIME_BRAZIL_ONLY_HOST_URL = "https://admin-cr-brl.web.app/";

const PRIME_BRAZIL_ONLY_HOSTNAME = "admin-cr-brl.web.app";

const PRIME_BRAZIL_ONLY_ALLOWED_PATHS = ["/prime-order-flow"] as const;

export const PAYSONIC_HOST_URL = "https://admin.paysonic.network/";

const PAYSONIC_HOSTNAMES = [
  "admin.paysonic.network",
  "admin-paysonic.web.app",
] as const;

const PAYSONIC_ALLOWED_PATHS = [
  "/",
  "/transactions",
  "/internal-transactions",
  "/prime-order-flow",
  "/balances",
  "/kyc",
  "/prime-dispute-resolution",
  "/analytics",
  "/cashier-management",
  "/settle-accounts",
  "/groups",
] as const;

export const isPrimeBrazilOnlyHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.location.hostname === PRIME_BRAZIL_ONLY_HOSTNAME;
};

export const isPathAllowedForPrimeBrazilOnly = (pathname: string): boolean => {
  return PRIME_BRAZIL_ONLY_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
};

export const isPaysonicHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return PAYSONIC_HOSTNAMES.includes(
    window.location.hostname as (typeof PAYSONIC_HOSTNAMES)[number],
  );
};

export const isPathAllowedForPaysonic = (pathname: string): boolean => {
  return PAYSONIC_ALLOWED_PATHS.some((path) => {
    if (path === "/") {
      return pathname === "/";
    }
    return pathname === path || pathname.startsWith(`${path}/`);
  });
};
